export const helpCenterNeighboprsUrl =
  'https://support.ring.com/hc/en-us/categories/360002020811-Neighbors';

export const crimeIncidentCategoryNonviolent = 'NONVIOLENT';
export const crimeIncidentCategoryViolent = 'VIOLENT';

const OTHER_CATEGORY = 'other';
export const AUTO_DECLINE = 'autodecline';
export const DENIAL_PREFIX = 'denial';
export const DEFAULT_CONTENTFUL_CATEGORY = DENIAL_PREFIX + ':' + OTHER_CATEGORY;
